import { http, toQuery } from '@/lib/apiClient';
import type { WorkflowInstance } from '@/api/workflows.api';
import type { LifecycleTimelineStage } from '@/api/lifecycleTimeline';

export type GoodsReceiptStatus = 'DRAFT' | 'PENDING_APPROVAL' | 'POSTED_TO_SAP' | 'REJECTED';
export type InspectionStatus = 'NOT_INSPECTED' | 'PENDING' | 'PASSED' | 'FAILED';

export interface GoodsReceiptQuery { page?: number; pageSize?: number; status?: string; search?: string; vendorId?: string }
export interface CreateGoodsReceiptRequest {
  poId: string;
  grnDate: string;
  isPartial: boolean;
  isFinalDelivery: boolean;
  deliveryNoteNumber?: string;
  remarks?: string;
  attachmentId?: string;
}
export interface InspectGoodsReceiptRequest { inspectionStatus: 'PASSED' | 'FAILED'; remarks?: string }
export interface GoodsReceipt {
  id: string;
  grnNumber?: string | null;
  poId: string;
  poNumber?: string | null;
  vendorId?: string | null;
  vendorName?: string | null;
  grnDate: string;
  status: GoodsReceiptStatus;
  isPartial: boolean;
  isFinalDelivery: boolean;
  deliveryNoteNumber?: string | null;
  remarks?: string | null;
  attachmentId?: string | null;
  inspectionStatus?: InspectionStatus | null;
  inspectionRemarks?: string | null;
  inspectedAt?: string | null;
  inspectedByName?: string | null;
  submittedAt?: string | null;
  approvedAt?: string | null;
  rejectedAt?: string | null;
  sapSyncStatus?: string | null;
  sapMaterialDoc?: string | null;
  createdAt?: string | null;
  workflowInstanceId?: string | null;
  workflowInstance?: WorkflowInstance | null;
  approvedByName?: string | null;
  lifecycleTimeline?: LifecycleTimelineStage[] | null;
}
export interface PagedGoodsReceipts { items: GoodsReceipt[]; page: number; pageSize: number; totalCount: number }

export const goodsReceiptsApi = {
  list: (query: GoodsReceiptQuery = {}) => http.get<PagedGoodsReceipts>(`/api/v1/goods-receipts${toQuery({ page: query.page ?? 1, pageSize: query.pageSize ?? 20, status: query.status, search: query.search, vendorId: query.vendorId })}`),
  getById: (id: string) => http.get<GoodsReceipt>(`/api/v1/goods-receipts/${id}`),
  create: (body: CreateGoodsReceiptRequest) => http.post<GoodsReceipt>('/api/v1/goods-receipts', body),
  inspect: (id: string, body: InspectGoodsReceiptRequest) => http.post<GoodsReceipt>(`/api/v1/goods-receipts/${id}/inspect`, body),
  submit: (id: string) => http.post<GoodsReceipt>(`/api/v1/goods-receipts/${id}/submit`),
};
